export const APP_COMMIT_HASH = import.meta.env.VITE_GIT_COMMIT_HASH;
export const APP_COMMIT_DATE = import.meta.env.VITE_GIT_COMMIT_DATE;
export const APP_VERSION = import.meta.env.VITE_GIT_VERSION;
